import React, { useState } from "react";
import UserListview from "./UserListview";
import UserForm from "./UserForm";

const Users = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <UserForm addForm={setFromIsShown} update={upData} sId={serviceId} />
      ) : (
        <UserListview addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
      )}
    </>
  );
};

export default Users;
